import { firstOf, G } from '@2l/utils'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useTCE } from '@/composables/useAny'
import { STORAGE_KEYS } from '@/constants/storageKeys'

const getErrorMessage = firstOf(G('message'), G('error.message'))
const getErrorDomain = firstOf(G('error.code'), getErrorMessage)
const getErrorCode = G('error.id')

// TODO: move to the auth store after migrating to Pinia
export async function authorizeBySessionRoute(route, store) {
  const session = route?.query?.session
  if (!session) return

  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, session)
  await store.commit('auth/CHECK')
  await store.dispatch('account/find')
}

export async function autoAuth(type = 'external_page') {
  const route = useRoute()
  const router = useRouter()
  const vuexStore = useStore()
  const tce = useTCE()

  if (!route?.meta?.allowSessionAuth) {
    return
  }

  try {
    await authorizeBySessionRoute(route, vuexStore)
    await tce('onboarding_registration', {
      subtype: 'autologin',
      type,
      action_result: 'success'
    })
  } catch (e) {
    await router.replace({ name: route.name })
    await vuexStore.commit('auth/LOGOUT')
    await vuexStore.dispatch('offers/getPlanProxy')
    await tce('onboarding_registration', {
      subtype: 'autologin',
      type,
      action_result: 'error',
      error_domain: getErrorDomain(e),
      error_code: getErrorCode(e)
    })
  }
}
